export default __webpack_public_path__ + "static/media/bdswissGlobalDemo_downloadMT4.a40f8429.png";